/* src/app/components/shared/product-banner-carousel/product-banner-carousel.component.scss */
.main-slider {
  height: 350px !important;
}
/*# sourceMappingURL=product-banner-carousel.component.css.map */
